import React, { Component } from 'react'
import AngleBracket from './angleBracket'
import Fade from 'react-reveal/Fade'

class Collapsable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCollapsed: this.props.isCollapsed || false,
    }
  }

  toggleCollapse = () =>
    this.setState(prevState => ({ isCollapsed: !prevState.isCollapsed }))

  render() {
    const { children, style, text, hideCardEffects } = this.props
    return (
      <div>
        <div
          style={{ ...defaultStyle, ...style, cursor: 'pointer' }}
          onClick={this.toggleCollapse}
          className={`unselectable ${!hideCardEffects ? 'card' : ''}`}
        >
          {text}
          <AngleBracket style={this.state.isCollapsed ? angleUp : angleDown} />
        </div>
        <Fade when={!this.state.isCollapsed} collapse>
          {children}
        </Fade>
      </div>
    )
  }
}

export default Collapsable

const defaultStyle = {
  padding: '1rem 1.5rem',
  background: 'white',
  fontFamily: '"Libre Franklin", "sans serif"',
  marginBottom: '0.5rem',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: 'bold',
}

const angleStyle = {
  height: 'auto',
  width: '0.35rem',
}

const angleUp = {
  ...angleStyle,
  transform: 'rotate(270deg)',
  filter: 'FlipH',
}

const angleDown = {
  ...angleStyle,
  transform: 'rotate(90deg)',
  filter: 'FlipH',
}



// WEBPACK FOOTER //
// ./src/components/shared/collapsable.js